import React from 'react';
import './Plasticratecontain.css';
import Plasticrat from '../../../imgs/Plasticratecontain.webp'; 

const Plasticratecontain = () => {
  return (
    <div className="Plasticratecont-container">
      <img src={Plasticrat} alt="Fitting Corrosion" className="Plasticratecont-image" />
    </div>
  );
};

export default Plasticratecontain;
